import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { crm, money } from "../lib/crmClient";

export function CrmDashboard() {
    const [stats, setStats] = useState({ clients: 0, invoices: 0, quotes: 0, revenue: 0, outstanding: 0 });

    useEffect(() => {
        Promise.all([
            crm.get("/crm/clients"),
            crm.get("/crm/invoices"),
        ]).then(([c, i]) => {
            const invs = i.data;
            setStats({
                clients: c.data.length,
                invoices: invs.filter((x) => x.kind === "invoice").length,
                quotes: invs.filter((x) => x.kind === "quote").length,
                revenue: invs.filter((x) => x.status === "paid").reduce((s, x) => s + (x.total || 0), 0),
                outstanding: invs
                    .filter((x) => x.kind === "invoice" && x.status !== "paid" && x.status !== "void")
                    .reduce((s, x) => s + (x.balance_due || x.total || 0), 0),
            });
        }).catch(() => {});
    }, []);

    const Card = ({ label, value, testId }) => (
        <div className="glass border border-white/15 p-6" data-testid={testId}>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50">{label}</div>
            <div className="font-display uppercase text-4xl md:text-5xl leading-none mt-3">{value}</div>
        </div>
    );

    return (
        <div data-testid="crm-dashboard">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50">[ Dashboard ]</div>
            <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tight mt-2">
                The <span className="rainbow-text">rolling</span> palette.
            </h1>

            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6 mt-10">
                <Card label="Clients" value={stats.clients} testId="stat-clients" />
                <Card label="Quotes" value={stats.quotes} testId="stat-quotes" />
                <Card label="Invoices" value={stats.invoices} testId="stat-invoices" />
                <Card label="Revenue" value={money(stats.revenue)} testId="stat-revenue" />
                <Card label="Outstanding" value={money(stats.outstanding)} testId="stat-outstanding" />
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
                <Link
                    to="/crm/invoices/new"
                    className="border border-[#FFE600] text-[#FFE600] hover:bg-[#FFE600] hover:text-black transition-colors px-6 py-3 font-mono text-[11px] tracking-[0.3em] uppercase"
                >
                    + New Invoice / Quote
                </Link>
                <Link
                    to="/crm/clients"
                    className="border border-white/30 hover:border-white transition-colors px-6 py-3 font-mono text-[11px] tracking-[0.3em] uppercase"
                >
                    Manage Clients →
                </Link>
            </div>
        </div>
    );
}
